import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { i18n } = useTranslation();
  const isEn = i18n.language && i18n.language.startsWith("en");

  return (
    <div style={{ padding: "2rem", maxWidth: 900, margin: "0 auto" }}>
      {isEn ? (
        <div>
          <h1>Privacy Policy</h1>
          <p>
            This website is operated by the Assembly of the Republic of Albania.
            We respect your privacy and process personal data in accordance with
            applicable law.
          </p>
          <h2>Data We Collect</h2>
          <p>
            We may collect data you provide directly (e.g., contact forms,
            subscriptions) and technical data (cookies, logs, IP address).
          </p>
          <h2>How We Use Data</h2>
          <p>
            Data is used to respond to requests, improve the site, and provide
            services. We do not sell personal data.
          </p>
          <h2>Cookies</h2>
          <p>
            We use cookies and similar technologies to improve functionality and
            analytics. You can manage cookie preferences in your browser.
          </p>
          <h2>Your Rights</h2>
          <p>
            You may request access, correction, or deletion of personal data
            stored by us. To exercise these rights, contact our data protection
            contact below.
          </p>
          <h2>Contact</h2>
          <p>For privacy inquiries, please contact: info@parlament.al</p>
        </div>
      ) : (
        <div>
          <h1>Politika e Privatësisë</h1>
          <p>
            Ky faqe menaxhohet nga Kuvendi i Republikës së Shqipërisë. Ne
            respektojmë privatësinë tuaj dhe përpunojmë të dhënat personale në
            përputhje me ligjin në fuqi.
          </p>
          <h2>Të dhënat që mbledhim</h2>
          <p>
            Mund të mbledhim të dhëna që ju jepni drejtpërdrejt (p.sh.,
            formularë kontakti, abonime) dhe të dhëna teknike (cookies, log-e,
            adresa IP).
          </p>
          <h2>Si i përdorim të dhënat</h2>
          <p>
            Të dhënat përdoren për t&apos;iu përgjigjur kërkesave, për të
            përmirësuar shërbimin dhe për ofrimin e shërbimeve. Ne nuk shesim të
            dhënat personale.
          </p>
          <h2>Cookie-t</h2>
          <p>
            Përdorim cookie dhe teknologji të ngjashme për funksionalitet dhe
            analiza. Mund të menaxhoni preferencat e cookie-ve në shfletuesin
            tuaj.
          </p>
          <h2>Të drejtat tuaja</h2>
          <p>
            Ju mund të kërkoni qasje, korrigjim ose fshirje të të dhënave
            personale që ruhen tek ne. Për të ushtruar këto të drejta,
            kontaktoni personin tonë përgjegjës për mbrojtjen e të dhënave.
          </p>
          <h2>Kontakt</h2>
          <p>Për pyetje rreth privatësisë: info@parlament.al</p>
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;
